// FILE: src/App.jsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import Home from './pages/home';
import About from './pages/About';

// import JoinMerchantNavy from './pages/joinmerchantnavy';
// import CargoToCruise from './pages/cargotocruise';
import Contact from './pages/contactus';
import Services from './pages/Services';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

function App() {
  return (
    <Router>
      <Header />
      <main style={{ paddingBottom: '40px' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          {/* <Route path="/joinmerchantnavy" element={<JoinMerchantNavy />} /> */}
          {/* <Route path="/cargotocruise" element={<CargoToCruise />} /> */}
          <Route path="/contactus" element={<Contact />} />
          <Route path="/Services" element={<Services />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
